/*
 * General Specifications collapse (show more / show less).
 *
 * The clamp is applied by JS only, so if this script fails the full table
 * still renders. Works for every product_specifications block on the page and
 * re-syncs after a variant change, since product-info.js swaps the block's
 * innerHTML in place.
 */
(function () {
  var reduceMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function panelOf(root) {
    return root.querySelector('[data-pd-collapse]');
  }

  function toggleOf(root) {
    return root.querySelector('[data-pd-toggle]');
  }

  function clampPx(el) {
    return parseInt(getComputedStyle(el).getPropertyValue('--pd-clamp'), 10) || 160;
  }

  function isOpen(root) {
    return root.dataset.pdOpen === 'true';
  }

  function setLabel(btn, open) {
    var text = btn.querySelector('[data-pd-toggle-text]');
    if (text) text.textContent = open ? btn.dataset.less || 'Show less' : btn.dataset.more || 'Show more';
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  // Decides whether the toggle is needed at all and restores the current state.
  function syncCollapse(root) {
    var el = panelOf(root);
    var btn = toggleOf(root);
    if (!el || !btn) return;

    var open = isOpen(root);

    el.style.maxHeight = '';
    el.classList.remove('is-open', 'is-clamped');

    if (el.scrollHeight <= clampPx(el) + 24) {
      btn.hidden = true;
      root.dataset.pdOpen = 'false';
      return;
    }

    el.classList.add('is-clamped');
    btn.hidden = false;

    if (open) {
      el.classList.add('is-open');
      el.style.maxHeight = 'none';
    }

    setLabel(btn, open);
  }

  function openPanel(root, el, btn) {
    root.dataset.pdOpen = 'true';
    el.classList.add('is-open');
    setLabel(btn, true);

    if (reduceMotion) {
      el.style.maxHeight = 'none';
      return;
    }

    el.style.maxHeight = el.scrollHeight + 'px';
    el.addEventListener('transitionend', function done(e) {
      if (e.propertyName !== 'max-height') return;
      el.removeEventListener('transitionend', done);
      el.style.maxHeight = 'none';
    });
  }

  function closePanel(root, el, btn) {
    root.dataset.pdOpen = 'false';
    setLabel(btn, false);

    if (reduceMotion) {
      el.style.maxHeight = '';
      el.classList.remove('is-open');
      return;
    }

    el.style.maxHeight = el.scrollHeight + 'px';
    void el.offsetHeight; // reflow, so the next value animates instead of snapping
    el.classList.remove('is-open');
    el.style.maxHeight = clampPx(el) + 'px';

    el.addEventListener('transitionend', function done(e) {
      if (e.propertyName !== 'max-height') return;
      el.removeEventListener('transitionend', done);
      el.style.maxHeight = '';
    });
  }

  function roots() {
    return document.querySelectorAll('.product__block--product_specifications');
  }

  function syncAll() {
    roots().forEach(syncCollapse);
  }

  // Delegated, so it survives the innerHTML swap on variant change.
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var btn = e.target.closest('[data-pd-toggle]');
    if (!btn) return;
    var root = btn.closest('.product__block--product_specifications');
    if (!root) return;
    var el = panelOf(root);
    if (!el) return;

    if (isOpen(root)) {
      closePanel(root, el, btn);
      if (el.getBoundingClientRect().top < 0) {
        el.scrollIntoView({ block: 'start', behavior: reduceMotion ? 'auto' : 'smooth' });
      }
    } else {
      openPanel(root, el, btn);
    }
  });

  var resizeTimer = null;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(syncAll, 200);
  });

  document.addEventListener('variant:changed', function () {
    // product-info.js swaps innerHTML; re-measure after the DOM settles.
    setTimeout(syncAll, 0);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncAll);
  } else {
    syncAll();
  }
})();
